var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrismaLogo = function SvgPrismaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2d3748",
    d: "M66.457.014a6.31 6.31 0 0 0-5.812 3.028l-47.87 78.072a6.38 6.38 0 0 0 .048 6.748l23.568 37.186a6.39 6.39 0 0 0 7.22 2.683l68.012-20.407a6.37 6.37 0 0 0 3.96-8.765l-43.72-94.85A6.3 6.3 0 0 0 66.46.014Zm1.795 23.95a2.35 2.35 0 0 1 2.448 1.433l30.16 69.784a2.39 2.39 0 0 1-1.512 3.241l-46.996 14.024a2.39 2.39 0 0 1-3.024-2.76l16.83-83.812a2.35 2.35 0 0 1 2.099-1.91z"
  })));
};
export default SvgPrismaLogo;